import { render, staticRenderFns } from "./admin-school-types.vue?vue&type=template&id=75e326ec&scoped=true"
import script from "./admin-school-types.vue?vue&type=script&lang=js"
export * from "./admin-school-types.vue?vue&type=script&lang=js"
import style0 from "./admin-school-types.vue?vue&type=style&index=0&id=75e326ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e326ec",
  null
  
)

export default component.exports